// utils/compressImage.js
export async function compressImage(
  file,
  maxSizeMB = 1,
  maxWidth = 1080,
  maxHeight = 720
) {
  if (!file || !file.type.startsWith("image/")) {
    throw new Error("Arquivo inválido");
  }

  const maxSizeBytes = maxSizeMB * 1024 * 1024;

  const canvasToBlob = (canvas, type, quality) => {
    return new Promise((resolve) => {
      canvas.toBlob(
        (blob) => resolve(blob),
        type,
        quality
      );
    });
  };

  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onload = async (event) => {
      const img = new Image();
      img.onload = async () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        let { width, height } = img;
        const ratio = Math.min(maxWidth / width, maxHeight / height, 1);
        width = Math.round(width * ratio);
        height = Math.round(height * ratio);

        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);

        let quality = 1.0;
        let blob = await canvasToBlob(canvas, "image/jpeg", quality); // força JPEG


        while (blob.size > maxSizeBytes && quality > 0.1) {
          quality -= 0.1;
          blob = await canvasToBlob(canvas, "image/jpeg", quality);
        }

        if (!blob) {
          return reject(new Error("Falha ao criar imagem comprimida"));
        }

        const compressedFile = new File([blob], file.name.replace(/\.[^/.]+$/, ".jpg"), {
          type: "image/jpeg",
          lastModified: Date.now(),
        });

        resolve(compressedFile);
      };
      img.src = event.target.result;
    };

    reader.onerror = (err) => reject(err);
    reader.readAsDataURL(file);
  });
}
